// TODO: Verify
export const sgs3x3x3: string[][] = [
  [
    "R U'",
    "R2 B", //
    "D2 B2",
    "D' L B'", //
    "R' U'",
    "B", //
    "D B2",
    "R' B", //
    "L' U",
    "L2 B'", //
    "B2",
    "D L B'", //
    "L U",
    "B'", //
    "U'",
    "R B", //
    "D' B2",
    "L B'", //
    "U2",
    "U L' B'", //
    "",
    "U' L' B'", //
    "U",
    "L' B'",
  ],
  [
    "F2 L2",
    "F' L'",
    "R' F L2", //
    "D' L2",
    "F L2",
    "F2 L'", //
    "R' F' L'",
    "R2 F L2",
    "R2 F2 L'", //
    "L2",
    "F L'",
    "D' L", //
    "D2 L2",
    "R2 F' L'",
    "D L", //
    "",
    "L2 F L'",
    "L F' L2", //
    "L F L'",
    "F' L2",
    "L'", //
    "D L2",
    "D F L'",
    "L",
  ],
  [
    "R B U2 B'",
    "R2 B U' B'", //
    "F2 B U B'",
    "F B2 L' B2", //
    "B2 L B2",
    "B U' B'", //
    "R2 B U2 B'",
    "R' B U' B'", //
    "B2 L' B2",
    "F B U B'", //
    "B2 U' B2",
    "B' L B", //
    "L F' B D' B'",
    "B' U' B2 D B'", //
    "B U2 B'",
    "R B U' B'", //
    "B2 L2 B2",
    "D' B' L B", //
    "B U B'",
    "F' B2 L' B2", //
    "",
    "B2 L' B' U' B'",
  ],
  [
    "U F2 L2 U'",
    "F' U L' U'", //
    "F2 U L' U'",
    "U F L2 U'", //
    "U2 B2 U2",
    "R' U' B U", //
    "D2 U L U'",
    "D U2 B' U2", //
    "U L2 U'",
    "F U L' U'", //
    "D U L U'",
    "U2 B' U2", //
    "",
    "U2 B' U' L' U'", //
    "U2 L' U2",
    "U' B U", //
    "U L U'",
    "D' U2 B' U2", //
    "U L' U'",
    "U2 B U2",
  ],
  [
    "R' D' F2",
    "F'", //
    "F2",
    "D R F'", //
    "R D' F2",
    "R2 F'", //
    "D' F2",
    "R F'", //
    "F2 R' D' F2",
    "F", //
    "D2 F2",
    "D' R F'", //
    "R2 D' F2",
    "R' F'", //
    "D F2",
    "D2 R F'", //
    "",
    "F R' D' F2",
  ],
  [
    "R' D2 F' D F",
    "R F2 R2 F2",
    "R2 F' D2 F", //
    "F' R2 D2 F",
    "L D' L'",
    "D F' D2 F", //
    "F2 R2 F2",
    "R F' D2 F",
    "F' R2 D' F", //
    "F' R' D2 F",
    "F2 R' F2",
    "L D L'", //
    "F' R D' F",
    "F2 R F2",
    "F' D2 F", //
    "",
    "L D2 R D' L'",
    "F' D2 F' R F2", //
    "D2 R2 F2 R2 F2",
    "D F' D' F",
    "F' D F",
  ],
  [
    "U F2 U'",
    "R U F' U'", //
    "D R U F2 U'",
    "U F U'", //
    "R2 U F2 U'",
    "R' U F' U'", //
    "R U F2 U'",
    "R2 U F' U'", //
    "",
    "U L D L' F U'", //
    "F2 D' R D F2",
    "D2 U F U'", //
    "R' U F2 U'",
    "U F' U'", //
    "F2 D2 R D2 F2",
    "D U F U'",
  ],
  [
    "R2",
    "R' B' D B", //
    "D R'",
    "F' R2 F", //
    "",
    "R B' D B", //
    "R'",
    "B' D B", //
    "D' R'",
    "D2 F' R2 F", //
    "R",
    "R2 B' D B", //
    "D2 R'",
    "B' D' B",
  ],
  [
    "R2 D' R2",
    "F' R' F R",
    "R D' R2 D R'", //
    "D2 R2 D2 R2",
    "R' D' F' R F",
    "U F D F' U'", //
    "",
    "R2 D2 B R' B' R'",
    "R' F D' F2 R F", //
    "R2 D R2",
    "F2 U F U' F",
    "R' D F' R F", //
    "D R2 D2 R2",
    "U F D' F' U'",
    "D R' D2 F' R F", //
    "R2 D2 R2",
    "U F D2 F' U'",
    "R' D2 F' R F",
  ],
  [
    "B R B'",
    "F D F' B R2 B'", //
    "D B R2 B'",
    "D2 B R' B'", //
    "B R2 B'",
    "D B R' B'", //
    "D' B R2 B'",
    "B R' B'", //
    "",
    "B R2 B' D B R' B'", //
    "D2 B R2 B'",
    "D' B R' B'",
  ],
  [
    "",
    "R' D R F D2 F'", //
    "R' D R",
    "D F D' F'", //
    "R F' R' F",
    "F D' F'", //
    "R' D' R",
    "F D2 F'", //
    "R' D2 R",
    "F D F'",
  ],
  [
    "",
    "F2 D2 R F' R' D2 F' D2 F'",
    "F2 D2 F' D' F D' F' D2 F'", //
    "F2 D F2 D F2 D2 F2",
    "D2 F L D2 L' D2 F'",
    "D F D2 L D2 L' F'", //
    "R' D B' D2 B D' R",
    "R' D2 B' D2 B R",
    "F D2 F' D F D F'", //
    "F D' L D2 L' D F'",
    "B D' F D B' D' F'",
    "F D2 L D2 L' F'", //
    "F D' L D L' D F'",
    "F L D2 L' D2 F'",
    "R' B' D2 B D2 R",
  ],
  [
    "D'",
    "F L D L' D' F'", //
    "D2",
    "L B D B' D' L'", //
    "D",
    "B' L' D' L D B", //
    "",
    "D F L D L' D' F'",
  ],
  [
    "F' D2 F D F' D F",
    "F' D' R' D R F", //
    "F' R' D' R D F",
    "B D R D' R' B'", //
    "",
    "D B' D' L' D L B",
  ],
  [
    "D F D F' D F D2 F'",
    "F' U2 B' R' B U2 F' L F' L' F'", //
    "",
    "D2 L D L2 F L F2 D F",
  ],
  [
    "L B' L' F L B L' F'",
    "F2 U F' D2 F U' F' D2 F'",
    "D' F' D B D' F D B'", //
    "F L2 F R2 F' L2 F R2 F2",
    "D B D' F' D B' D' F",
    "R F L F' R' F L' F'", //
    "",
    "D2 B L' U2 L B' D2 B L' U2 L B'",
    "D2 F R' U2 R F' D2 F R' U2 R F'", //
    "R F L' F' R' F L F'",
    "D F D' B' D F' D' B",
    "L2 F2 L' B2 L F2 L' B2 L'",
  ],
  [
    "L B R' B' L' B R B'",
    "R' B R F' R' B' R F",
    "L D2 L U L' D2 L U' L2", //
    "",
    "D2 B' D2 F D' L2 F L2 F' D2 B D' F'",
    "D2 F' R' F R2 B' D2 B D2 R' F D2 F'", //
    "L B L' F L B' L' F'",
    "F' D2 F' U' F D2 F' U F2",
    "D' B' D F D' B D F'",
  ],
  ["", "D2 F' L U2 L' F D2 F' L U2 L' F", "D2 B' R U2 R' B D2 B' R U2 R' B"],
];
